import { useEffect, useState } from 'react';
import { portalApi } from '../../services/portalApi';
import type { Estate } from '../../types';

export default function TrusteeSettings() {
  const [estate, setEstate] = useState<Estate | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    portalApi.getEstate().then(setEstate).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="px-6 py-12 text-gray-400">Loading…</div>;
  if (!estate) return <div className="px-6 py-12 text-gray-400">Could not load settings.</div>;

  return (
    <div className="px-6 py-6 max-w-2xl">
      <div className="mb-6">
        <h1 className="text-lg font-semibold text-gray-900">Settings</h1>
        <p className="text-sm text-gray-500">Read-only view</p>
      </div>

      <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
        <div className="px-5 py-4">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Estate name</p>
          <p className="text-sm text-gray-900">{estate.name}</p>
        </div>
        <div className="px-5 py-4">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Address</p>
          <p className="text-sm text-gray-900">{estate.address || '—'}</p>
        </div>
        <div className="px-5 py-4">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">Subscription</p>
          <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium capitalize ${
            estate.subscription_status === 'active' ? 'bg-green-100 text-green-700' :
            estate.subscription_status === 'trial'  ? 'bg-blue-100 text-blue-700' :
            'bg-red-100 text-red-700'
          }`}>
            {estate.subscription_status}
          </span>
        </div>
        <div className="px-5 py-4">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">Alarm email addresses</p>
          {estate.alarm_contacts.length === 0 ? (
            <p className="text-sm text-gray-400">None configured</p>
          ) : (
            <ul className="space-y-1">
              {estate.alarm_contacts.map((c) => (
                <li key={c} className="text-sm text-gray-700">{c}</li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
